import type { Database } from "../../../__definitions__/database-definitions";
import { SupabaseService } from "../../../server/supabase/base-supabase-service";

export type FollowUp = Database["public"]["Tables"]["follow_up"]["Row"];

export type MomentExistingFollowUps =
  Database["public"]["Functions"]["moment_existing_follow_ups"]["Returns"][number];

export class SupabaseFollowUpService extends SupabaseService<"follow_up"> {
  table = "follow_up" as const;
}
